<cc-box>
  <div class="lg-container" box header>{{'LEAD_GENERATION.CREATOR.POPUP.TEXT' | translate }}</div>
  <div box content>
    <cc-lg-label-input icon="title" label="{{'LEAD_GENERATION.CREATOR.POPUP.TITLE' | translate }}"
                       [control]="popupSettings.controls.title"></cc-lg-label-input>
    <cc-lg-label-input [textarea]="true" icon="description" label="{{'LEAD_GENERATION.CREATOR.POPUP.DESCRIPTION' | translate }}"
                       [control]="popupSettings.controls.description"></cc-lg-label-input>
    <cc-lg-label-input icon="button" label="{{'LEAD_GENERATION.CREATOR.POPUP.BUTTON' | translate }}"
                       [control]="popupSettings.controls.buttonText"></cc-lg-label-input>
    <cc-lg-label-input icon="title" label="{{'LEAD_GENERATION.CREATOR.POPUP.THANK_YOU_MESSAGE_TITLE' | translate }}"
                       [control]="popupSettings.controls.thanksTitle"></cc-lg-label-input>
    <cc-lg-label-input icon="thanks" label="{{'LEAD_GENERATION.CREATOR.POPUP.THANK_YOU_MESSAGE' | translate }}"
                       [control]="popupSettings.controls.thanksText"></cc-lg-label-input>
    <cc-lg-label-input icon="error-message" label="{{'LEAD_GENERATION.CREATOR.POPUP.ERROR_MESSAGE' | translate }}"
                       [control]="popupSettings.controls.errorMessage"></cc-lg-label-input>
  </div>
</cc-box>
